import { FeatureFlag, useIsFlagEnabled } from '@/hooks/useIsFlagEnabled'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { isStaff } from '@/utils/type-guards'

import { useElaraRealtimeLicenseEnabled } from './useElaraRealtimeLicenseEnabled'

/**
 * Whether the ELARA chat (FAB, side panel, sidebar entry, dashboard search) is available.
 * The elara-realtime licence always grants it; with `dashboard-elara-omnibox` on, every staff
 * user gets it. The in-consultation realtime companion still requires the licence
 * (see `useElaraRealtimeLicenseEnabled`).
 */
export function useElaraChatEnabled(): boolean {
  const hasRealtimeLicense = useElaraRealtimeLicenseEnabled()
  const isOpenToAllStaff = useIsFlagEnabled(FeatureFlag.DashboardElaraOmnibox)
  const authUser = useAppSelector(selectAuthUser)
  return hasRealtimeLicense || (isOpenToAllStaff && isStaff(authUser))
}
